import React ,{ useState } from 'react'
import styled from 'styled-components'
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import {selectCars} from '../features/car/carSlice';
import { useSelector } from 'react-redux';

function Header() {
   const [burgerStatus, setBurgerStatus] = useState(false);
   const Cars =  useSelector(selectCars);
  
    return (
        
        <Container>
            <a>
               <h1>Car way</h1>
            </a>
            <Mune>
               
              
              
                {Cars && Cars.map((car , index)=>(
                      <p>
                      <a key={index} href="#">
                        {car}
                      </a>
                  </p>
                ))}
                
                
               
            
            </Mune>
            <RightMune>
                <a href="#">Shop</a>
                <a href="#">your Account</a>
                <MenuIcon onClick={()=>setBurgerStatus(true)} />
            </RightMune>
            <BurgerNav show={burgerStatus}>
                <CloseWrapper>
                <CloseIcon onClick={()=>setBurgerStatus(false)} />

                </CloseWrapper>
               {Cars && Cars.map((car , index)=>(
                     <li>
                      <a key={index} href="#">
                        {car}
                      </a>
                      </li>
                
                ))}
            <li><a href="#">Exiesting Inventory</a></li>
            <li><a href="#">Used Inventory</a></li>
            <li><a href="#">Trade-in</a></li>
            <li><a href="#">CuberTruck</a></li>
            <li><a href="#">Roadtest</a></li>
            

            </BurgerNav>
        </Container>
    )
}

export default Header


const Container = styled.div`

min-height: 60px;
position: fixed;
display: flex;
align-items: center;
justify-content: space-between;
padding: 0 20px;
top: 0;
left: 0;
right: 0;
z-index: 1;

`


const Mune = styled.div`

display: flex;
align-items: center;
justify-content: center;
flex: 1;

p{
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
}

@media (max-width: 750px){
    display: none;
}


`

const RightMune = styled.div`
display: flex;
align-items: center;
a{
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
}
`

const BurgerNav = styled.div`
position: fixed;
top: 0;
right: 0;
bottom: 0;
background: white;
width:200px;
list-style: none;
padding: 20px;
text-align: start;
transform: ${props=>props.show ? 'translateX(0)' : 'translateX(100%)'};
transition: transform 0.2s ease-in;

li{
    padding: 15px 0;
    border-bottom: 1px solid rgba(0,0,0, .2);

    a{
        font-weight: 600;
    }
}

`

const CloseWrapper = styled.div`
display: flex;
justify-content: flex-end;
cursor:pointer;
`


